import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Phone, Download, CheckCircle2 } from "lucide-react";
import heroBackground from "@/assets/hero-background-new.jpg?format=webp&w=1920";
import heroBackgroundFallback from "@/assets/hero-background-new.jpg";
import saicaBadge from "@/assets/saica-badge.png?format=webp&w=200";
import saicaBadgeFallback from "@/assets/saica-badge.png";

const trustBadges = [
  "SAICA Registered",
  "SARS Compliance Support",
  "CIPC Annual Returns",
  "Payroll & UIF",
];

export function HeroSection() {
  return (
    <section className="relative overflow-hidden min-h-[90vh] bg-white">
      {/* Background image - using img for better LCP */}
      <picture>
        <source srcSet={heroBackground} type="image/webp" />
        <img
          src={heroBackgroundFallback}
          alt=""
          role="presentation"
          fetchPriority="high"
          decoding="async"
          className="absolute inset-0 w-full h-full object-cover"
          width={1920}
          height={1080}
        />
      </picture>
      
      <div className="container mx-auto px-4 py-20 lg:py-32 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-muted rounded-full px-4 py-2 mb-8 animate-fade-up">
            <span className="w-2 h-2 rounded-full bg-primary"></span>
            <span className="text-sm font-medium text-foreground">
              Trusted by South African Businesses
            </span>
          </div>
          
          {/* Headline */}
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-6 animate-fade-up stagger-1 leading-tight text-center">
            Bookkeeping Services
            <span className="block">South Africa</span>
          </h1>
          
          {/* Subtext */}
          <p className="text-lg md:text-xl text-muted-foreground mb-10 max-w-2xl mx-auto animate-fade-up stagger-2 leading-relaxed">
            From monthly bookkeeping and VAT, payroll to annual financial statements, income tax and CIPC compliance — 
            we handle your financial admin so you can focus on growing your business.
          </p>
          
          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16 animate-fade-up stagger-3">
            <Link to="/book-a-call">
              <Button size="lg" className="btn-primary gap-2 text-base px-8 h-14">
                <Phone className="w-5 h-5" />
                Book a Call
              </Button>
            </Link>
            <a href="/BOOKKEEPING_SERVICES_SA_packages.pdf" download>
              <Button size="lg" variant="outline" className="btn-outline-primary gap-2 text-base px-8 h-14">
                View Packages
                <Download className="w-5 h-5" />
              </Button>
            </a>
          </div>
          
          {/* Trust Badges */}
          <div className="flex flex-wrap justify-center gap-3 animate-fade-up stagger-4">
            {trustBadges.map((badge) => (
              <div key={badge} className="trust-badge bg-primary/10 text-foreground border-primary/20">
                <CheckCircle2 className="w-4 h-4 text-primary" />
                {badge}
              </div>
            ))}
          </div>
          
          {/* SAICA Accreditation */}
          <div className="mt-10 animate-fade-up stagger-4">
            <picture>
              <source srcSet={saicaBadge} type="image/webp" />
              <img 
                src={saicaBadgeFallback} 
                alt="SAICA Registered - South African Institute of Chartered Accountants" 
                className="h-12 mx-auto opacity-70 hover:opacity-100 transition-opacity"
                width={200}
                height={283}
                loading="lazy"
                decoding="async"
              />
            </picture>
          </div>
        </div>
      </div>
    </section>
  );
}
